import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { anchorCdnUrl } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import PaymentMethodPanel from './PaymentMethodPanel';
const brandLogos = {
    jcb: 'jcb.svg',
    amex: 'amex.svg',
    visa: 'visa.svg',
    mastercard: 'mastercard.svg',
    discover: 'discover.svg',
    diners: 'diners-club.svg',
    unionpay: 'unionpay.svg'
};
const defaultCardLogo = 'default-card.svg';
export default function CreditCardPanel(props) {
    const { t: texts } = useLocaleKeys('components.creditCardPanel');
    const { creditCard } = props;
    const { last4, creditCard: { brand, expiry } } = creditCard;
    return /*#__PURE__*/ _jsx(PaymentMethodPanel, _object_spread_props(_object_spread({}, props), {
        title: texts.title(),
        description: "****".concat(last4).concat(expiry ? " ".concat(texts.expiresDate({
            month: expiry.month,
            year: expiry.year
        })) : ''),
        logo: /*#__PURE__*/ _jsx("img", {
            alt: "credit card logo",
            "data-testid": "credit-card-logo",
            src: "".concat(anchorCdnUrl, "/images/credit-cards/").concat(brandLogos[brand] || defaultCardLogo)
        })
    }));
}
